// actions/connect/cannedResponses.js

import { attachAuth } from '../../utils/authService';

// --- GET ---

export function cannedResponsesGetHasErrored(bool) {
  return {
    type: 'CANNED_RESPOSNES_GET_HAS_ERRORED',
    hasErrored: bool
  };
}

export function cannedResponsesGetIsLoading(bool) {
  return {
    type: 'CANNED_RESPOSNES_GET_IS_LOADING',
    isLoading: bool
  };
}

export function cannedResponsesGetFetchDataSuccess(list) {
  return {
    type: 'CANNED_RESPOSNES_GET_FETCH_DATA_SUCCESS',
    list
  };
}

export function cannedResponsesGetFetchData(host) {
  return (dispatch) => {
    dispatch(cannedResponsesGetIsLoading(true));
    dispatch(cannedResponsesGetHasErrored(false));
    fetch(host + 'connect/admin/canned/get_private', {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(cannedResponsesGetFetchDataSuccess(result));
            dispatch(cannedResponsesGetHasErrored(false));
            dispatch(cannedResponsesGetIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(cannedResponsesGetHasErrored(true));
            dispatch(cannedResponsesGetIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(cannedResponsesGetHasErrored(true));
      dispatch(cannedResponsesGetIsLoading(false));
    });
  };
}

// --- ADD ---

export function cannedResponsesAddHasErrored(bool) {
  return {
    type: 'CANNED_RESPOSNES_ADD_HAS_ERRORED',
    hasErrored: bool
  };
}

export function cannedResponsesAddIsLoading(bool) {
  return {
    type: 'CANNED_RESPOSNES_ADD_IS_LOADING',
    isLoading: bool
  };
}

export function cannedResponsesAddFetchDataSuccess(obj) {
  return {
    type: 'CANNED_RESPOSNES_ADD_FETCH_DATA_SUCCESS',
    obj
  };
}

export function cannedResponsesAddFetchData(host, msg) {
  return (dispatch) => {
    dispatch(cannedResponsesGetIsLoading(true));
    dispatch(cannedResponsesGetHasErrored(false));
    fetch(host + 'connect/admin/canned/add', {
      method: 'post',
      body: JSON.stringify(msg),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(cannedResponsesGetFetchDataSuccess(result));
            dispatch(cannedResponsesAddFetchDataSuccess(result));
            dispatch(cannedResponsesAddHasErrored(false));
            dispatch(cannedResponsesAddIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(cannedResponsesAddHasErrored(true));
            dispatch(cannedResponsesAddIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(cannedResponsesAddHasErrored(true));
      dispatch(cannedResponsesAddIsLoading(false));
    });
  };
}

// --- UPDATE ---

export function cannedResponsesUpdateHasErrored(bool) {
  return {
    type: 'CANNED_RESPOSNES_UPDATE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function cannedResponsesUpdateIsLoading(bool) {
  return {
    type: 'CANNED_RESPOSNES_UPDATE_IS_LOADING',
    isLoading: bool
  };
}

export function cannedResponsesUpdateFetchDataSuccess(obj) {
  return {
    type: 'CANNED_RESPOSNES_UPDATE_FETCH_DATA_SUCCESS',
    obj
  };
}

export function cannedResponsesUpdateFetchData(host, msg) {
  return (dispatch) => {
    dispatch(cannedResponsesUpdateIsLoading(true));
    dispatch(cannedResponsesUpdateHasErrored(false));
    fetch(host + 'connect/admin/canned/update', {
      method: 'post',
      body: JSON.stringify(msg),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(cannedResponsesGetFetchDataSuccess(result));
            dispatch(cannedResponsesUpdateFetchDataSuccess(result));
            dispatch(cannedResponsesUpdateHasErrored(false));
            dispatch(cannedResponsesUpdateIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(cannedResponsesUpdateHasErrored(true));
            dispatch(cannedResponsesUpdateIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(cannedResponsesUpdateHasErrored(true));
      dispatch(cannedResponsesUpdateIsLoading(false));
    });
  };
}

// --- DELETE ---

export function cannedResponsesDeleteHasErrored(bool) {
  return {
    type: 'CANNED_RESPOSNES_DELETE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function cannedResponsesDeleteIsLoading(bool) {
  return {
    type: 'CANNED_RESPOSNES_DELETE_IS_LOADING',
    isLoading: bool
  };
}

export function cannedResponsesDeleteFetchDataSuccess(obj) {
  return {
    type: 'CANNED_RESPOSNES_DELETE_FETCH_DATA_SUCCESS',
    obj
  };
}

export function cannedResponsesDeleteFetchData(host, msg) {
  return (dispatch) => {
    dispatch(cannedResponsesDeleteIsLoading(true));
    dispatch(cannedResponsesDeleteHasErrored(false));
    fetch(host + 'connect/admin/canned/delete', {
      method: 'post',
      body: JSON.stringify(msg),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(cannedResponsesGetFetchDataSuccess(result));
            dispatch(cannedResponsesDeleteFetchDataSuccess(result));
            dispatch(cannedResponsesDeleteHasErrored(false));
            dispatch(cannedResponsesDeleteIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(cannedResponsesDeleteHasErrored(true));
            dispatch(cannedResponsesDeleteIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(cannedResponsesDeleteHasErrored(true));
      dispatch(cannedResponsesDeleteIsLoading(false));
    });
  };
}



